// ============================================
// FOOTBALLGIRL — shopData.js
// 84 placeholder products, numbered 1–84
// Categories aligned to two-level hierarchy
// Colourways: Home (navy/blue/white), Away (red/coral/gold), Neutral (black/grey/cream)
// ============================================

export const SHOP_CATEGORIES = [
    {
      label: 'Sport & Training',
      slug: 'sport-training',
      subcategories: [
        'Tops & T-Shirts', 'Sports Bras', 'Shorts',
        'Leggings & Tights', 'Sweatshirts & Hoodies',
        'Tracksuits', 'Jackets', 'Socks'
      ]
    },
    {
      label: 'Casual & Street',
      slug: 'casual-street',
      subcategories: [
        'Oversized Tees', 'Joggers', 'Caps & Beanies',
        'Tote Bags', 'Backpacks', 'Crossbody Bags'
      ]
    },
    {
      label: 'Home & Living',
      slug: 'home-living',
      subcategories: [
        'Mugs', 'Water Bottles', 'Towels',
        'Pillowcases', 'Blankets & Throws',
        'Posters & Art Prints', 'Candles'
      ]
    },
    {
      label: 'Tech & Accessories',
      slug: 'tech-accessories',
      subcategories: [
        'Phone Cases', 'Notebooks & Stationery',
        'Keyrings', 'Stickers & Badges', 'Scarves'
      ]
    },
    {
      label: 'Kids & Baby',
      slug: 'kids-baby',
      subcategories: [
        'Baby Bodysuits', 'Kids T-Shirts', 'Kids Hoodies'
      ]
    },
    {
      label: 'Gift Sets',
      slug: 'gift-sets',
      subcategories: [
        'Match Day Bundle', 'Home Comforts Bundle',
        'Baby Shower Bundle'
      ]
    }
  ];
  
  // ============================================
  // COLOUR PALETTE REFERENCE
  // Home:    #1a3a6b (navy), #1e5fbd (royal blue), #f0f4ff (white/light)
  // Away:    #c0392b (red), #e8845a (coral), #d4a017 (gold)
  // Neutral: #1a1a1a (black), #6b6b6b (grey), #f5f0eb (cream)
  // ============================================
  
  export const SHOP_PRODUCTS = [
  
    // ============================================
    // SPORT & TRAINING — Tops & T-Shirts (1–6)
    // ============================================
    {
      id: 'fg-001',
      name: 'Product 1',
      subtitle: 'Performance Training Top — Home',
      price: '£28.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Tops & T-Shirts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'A lightweight performance training top in the Home colourway. Designed for high-intensity sessions with moisture-wicking fabric.',
      details: ['95% Recycled Polyester, 5% Elastane', 'Moisture-wicking', 'Flatlock seams', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-002',
      name: 'Product 2',
      subtitle: 'Performance Training Top — Away',
      price: '£28.00',
      colors: ['#c0392b', '#e8845a'],
      isRecycled: true,
      imagePlaceholder: '#c0392b',
      category: 'Tops & T-Shirts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'A lightweight performance training top in the Away colourway. Bold red and coral tones built for the pitch.',
      details: ['95% Recycled Polyester, 5% Elastane', 'Moisture-wicking', 'Flatlock seams', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-003',
      name: 'Product 3',
      subtitle: 'Performance Training Top — Neutral',
      price: '£28.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Tops & T-Shirts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'A sleek training top in our Neutral colourway. Black and grey tones that go with everything.',
      details: ['100% Polyester', 'Moisture-wicking', 'Slim fit', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-004',
      name: 'Product 4',
      subtitle: 'Match Day Tee — Home',
      price: '£32.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1e5fbd',
      category: 'Tops & T-Shirts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Match day ready in royal blue and white. Lightweight and breathable for 90 minutes and beyond.',
      details: ['90% Recycled Polyester, 10% Cotton', 'Breathable mesh panels', 'Regular fit', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-005',
      name: 'Product 5',
      subtitle: 'Match Day Tee — Away',
      price: '£32.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: true,
      imagePlaceholder: '#d4a017',
      category: 'Tops & T-Shirts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'The Away edition match day tee. Red and gold — for when you mean business on the road.',
      details: ['90% Recycled Polyester, 10% Cotton', 'Breathable mesh panels', 'Regular fit', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-006',
      name: 'Product 6',
      subtitle: 'Match Day Tee — Neutral',
      price: '£32.00',
      colors: ['#6b6b6b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Tops & T-Shirts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'The Neutral match day tee. Grey and cream — understated, confident, always right.',
      details: ['100% Cotton', 'Regular fit', 'Crew neck', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Sports Bras (7–12)
    // ============================================
    {
      id: 'fg-007',
      name: 'Product 7',
      subtitle: 'High Support Sports Bra — Home',
      price: '£35.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Sports Bras',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      images: [],
      description: 'High support sports bra for high-intensity training. Encapsulation design in our Home navy colourway.',
      details: ['80% Recycled Nylon, 20% Elastane', 'High support', 'Removable pads', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10 }
    },
    {
      id: 'fg-008',
      name: 'Product 8',
      subtitle: 'High Support Sports Bra — Away',
      price: '£35.00',
      colors: ['#c0392b', '#e8845a'],
      isRecycled: true,
      imagePlaceholder: '#c0392b',
      category: 'Sports Bras',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      images: [],
      description: 'High support sports bra in the Away red and coral colourway. Built for every drill, sprint and match.',
      details: ['80% Recycled Nylon, 20% Elastane', 'High support', 'Removable pads', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10 }
    },
    {
      id: 'fg-009',
      name: 'Product 9',
      subtitle: 'High Support Sports Bra — Neutral',
      price: '£35.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Sports Bras',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      images: [],
      description: 'Classic black high support sports bra. Pairs with everything. Goes everywhere.',
      details: ['82% Nylon, 18% Elastane', 'High support', 'Removable pads', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10 }
    },
    {
      id: 'fg-010',
      name: 'Product 10',
      subtitle: 'Medium Support Bra — Home',
      price: '£28.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1e5fbd',
      category: 'Sports Bras',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      images: [],
      description: 'Medium support sports bra for yoga, pilates and light training. Soft and supportive in royal blue.',
      details: ['75% Recycled Polyester, 25% Elastane', 'Medium support', 'Removable pads', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10 }
    },
    {
      id: 'fg-011',
      name: 'Product 11',
      subtitle: 'Medium Support Bra — Away',
      price: '£28.00',
      colors: ['#d4a017', '#e8845a'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Sports Bras',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      images: [],
      description: 'Medium support bra in warm gold and coral. For training sessions that need style as well as function.',
      details: ['78% Polyester, 22% Elastane', 'Medium support', 'Removable pads', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10 }
    },
    {
      id: 'fg-012',
      name: 'Product 12',
      subtitle: 'Medium Support Bra — Neutral',
      price: '£28.00',
      colors: ['#6b6b6b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#f5f0eb',
      category: 'Sports Bras',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL'],
      images: [],
      description: 'Medium support bra in soft cream. The most versatile piece in your kit bag.',
      details: ['80% Polyester, 20% Elastane', 'Medium support', 'Removable pads', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Shorts (13–18)
    // ============================================
    {
      id: 'fg-013',
      name: 'Product 13',
      subtitle: 'Training Shorts — Home',
      price: '£30.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Shorts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Lightweight training shorts in Home navy. Side pockets, inner brief, 5" inseam.',
      details: ['90% Recycled Polyester, 10% Elastane', 'Inner brief', '5" inseam', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-014',
      name: 'Product 14',
      subtitle: 'Training Shorts — Away',
      price: '£30.00',
      colors: ['#c0392b', '#e8845a'],
      isRecycled: true,
      imagePlaceholder: '#c0392b',
      category: 'Shorts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Training shorts in Away red. Bold on the pitch, built for performance everywhere else.',
      details: ['90% Recycled Polyester, 10% Elastane', 'Inner brief', '5" inseam', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-015',
      name: 'Product 15',
      subtitle: 'Training Shorts — Neutral',
      price: '£30.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Shorts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Classic grey training shorts. The ones you reach for every time.',
      details: ['100% Polyester', 'Inner brief', '5" inseam', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-016',
      name: 'Product 16',
      subtitle: 'Bike Shorts — Home',
      price: '£34.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Shorts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: '8" bike shorts in deep navy. Compression fit, high waist, go from training to street.',
      details: ['80% Recycled Nylon, 20% Elastane', 'High waist', '8" inseam', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-017',
      name: 'Product 17',
      subtitle: 'Bike Shorts — Away',
      price: '£34.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Shorts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Gold and red bike shorts. High waist compression for training and beyond.',
      details: ['82% Nylon, 18% Elastane', 'High waist', '8" inseam', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-018',
      name: 'Product 18',
      subtitle: 'Bike Shorts — Neutral',
      price: '£34.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Shorts',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Black bike shorts. A wardrobe essential. Wear them everywhere.',
      details: ['82% Nylon, 18% Elastane', 'High waist', '8" inseam', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Leggings & Tights (19–24)
    // ============================================
    {
      id: 'fg-019',
      name: 'Product 19',
      subtitle: 'Full Length Leggings — Home',
      price: '£42.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Leggings & Tights',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Full length high-waist leggings in Home navy. Four-way stretch, squat-proof, pockets.',
      details: ['75% Recycled Polyester, 25% Elastane', 'High waist', 'Side pocket', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-020',
      name: 'Product 20',
      subtitle: 'Full Length Leggings — Away',
      price: '£42.00',
      colors: ['#c0392b', '#e8845a'],
      isRecycled: true,
      imagePlaceholder: '#c0392b',
      category: 'Leggings & Tights',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Full length leggings in Away red. Makes a statement on the pitch and in the gym.',
      details: ['75% Recycled Polyester, 25% Elastane', 'High waist', 'Side pocket', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-021',
      name: 'Product 21',
      subtitle: 'Full Length Leggings — Neutral',
      price: '£42.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Leggings & Tights',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Black full length leggings. The ones that go with every top you own.',
      details: ['78% Nylon, 22% Elastane', 'High waist', 'Side pocket', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-022',
      name: 'Product 22',
      subtitle: '7/8 Leggings — Home',
      price: '£38.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1e5fbd',
      category: 'Leggings & Tights',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: '7/8 length leggings in royal blue. Cropped for airflow, full coverage where it counts.',
      details: ['75% Recycled Polyester, 25% Elastane', 'High waist', '7/8 length', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-023',
      name: 'Product 23',
      subtitle: '7/8 Leggings — Away',
      price: '£38.00',
      colors: ['#d4a017', '#e8845a'],
      isRecycled: false,
      imagePlaceholder: '#e8845a',
      category: 'Leggings & Tights',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: '7/8 leggings in coral and gold. The warm colourway that makes training feel like a celebration.',
      details: ['78% Polyester, 22% Elastane', 'High waist', '7/8 length', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'high',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-024',
      name: 'Product 24',
      subtitle: '7/8 Leggings — Neutral',
      price: '£38.00',
      colors: ['#6b6b6b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Leggings & Tights',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Grey 7/8 leggings. Soft, stretchy and effortlessly versatile.',
      details: ['80% Polyester, 20% Elastane', 'High waist', '7/8 length', 'Machine wash 30°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Sweatshirts & Hoodies (25–30)
    // ============================================
    {
      id: 'fg-025',
      name: 'Product 25',
      subtitle: 'Pullover Hoodie — Home',
      price: '£55.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Sweatshirts & Hoodies',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Heavyweight pullover hoodie in Home navy. Kangaroo pocket, brushed interior, oversized fit.',
      details: ['60% Recycled Cotton, 40% Recycled Polyester', 'Brushed interior', 'Oversized fit', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-026',
      name: 'Product 26',
      subtitle: 'Pullover Hoodie — Away',
      price: '£55.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Sweatshirts & Hoodies',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Heavyweight pullover hoodie in Away red. Makes a statement everywhere you take it.',
      details: ['65% Cotton, 35% Polyester', 'Brushed interior', 'Oversized fit', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-027',
      name: 'Product 27',
      subtitle: 'Pullover Hoodie — Neutral',
      price: '£55.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Sweatshirts & Hoodies',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Classic black pullover hoodie. The foundation of every great wardrobe.',
      details: ['65% Cotton, 35% Polyester', 'Brushed interior', 'Oversized fit', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-028',
      name: 'Product 28',
      subtitle: 'Crew Sweatshirt — Home',
      price: '£48.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1e5fbd',
      category: 'Sweatshirts & Hoodies',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Crew neck sweatshirt in royal blue. Clean, minimal, endlessly wearable.',
      details: ['60% Recycled Cotton, 40% Recycled Polyester', 'Ribbed collar and cuffs', 'Regular fit', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-029',
      name: 'Product 29',
      subtitle: 'Crew Sweatshirt — Away',
      price: '£48.00',
      colors: ['#e8845a', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#e8845a',
      category: 'Sweatshirts & Hoodies',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Crew sweatshirt in warm coral. Effortless autumn dressing.',
      details: ['65% Cotton, 35% Polyester', 'Ribbed collar and cuffs', 'Regular fit', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-030',
      name: 'Product 30',
      subtitle: 'Crew Sweatshirt — Neutral',
      price: '£48.00',
      colors: ['#6b6b6b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#f5f0eb',
      category: 'Sweatshirts & Hoodies',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Cream crew sweatshirt. Soft, warm, goes with everything.',
      details: ['65% Cotton, 35% Polyester', 'Ribbed collar and cuffs', 'Regular fit', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Tracksuits (31–33)
    // ============================================
    {
      id: 'fg-031',
      name: 'Product 31',
      subtitle: 'Tracksuit Set — Home',
      price: '£95.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Tracksuits',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Matching zip hoodie and jogger set in Home navy. Sold as a set. Wear together or apart.',
      details: ['60% Recycled Cotton, 40% Recycled Polyester', 'Zip hoodie + jogger', 'Sold as set', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-032',
      name: 'Product 32',
      subtitle: 'Tracksuit Set — Away',
      price: '£95.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Tracksuits',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Matching tracksuit set in Away red and gold. The boldest thing in your wardrobe.',
      details: ['65% Cotton, 35% Polyester', 'Zip hoodie + jogger', 'Sold as set', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-033',
      name: 'Product 33',
      subtitle: 'Tracksuit Set — Neutral',
      price: '£95.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Tracksuits',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'All-black tracksuit set. Clean, powerful, timeless.',
      details: ['65% Cotton, 35% Polyester', 'Zip hoodie + jogger', 'Sold as set', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Jackets (34–36)
    // ============================================
    {
      id: 'fg-034',
      name: 'Product 34',
      subtitle: 'Bomber Jacket — Home',
      price: '£75.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Jackets',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Bomber jacket in Home navy. Ribbed cuffs, zip pockets, satin lining.',
      details: ['100% Recycled Polyester shell', 'Satin lining', 'Zip pockets', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-035',
      name: 'Product 35',
      subtitle: 'Bomber Jacket — Away',
      price: '£75.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Jackets',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Gold bomber jacket with red detailing. The away kit you actually want to wear.',
      details: ['100% Polyester shell', 'Satin lining', 'Zip pockets', 'Machine wash 30°'],
      collection: 'Match Day',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-036',
      name: 'Product 36',
      subtitle: 'Bomber Jacket — Neutral',
      price: '£75.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Jackets',
      parentCategory: 'Sport & Training',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Black bomber jacket. The one you wear everywhere.',
      details: ['100% Polyester shell', 'Satin lining', 'Zip pockets', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // SPORT & TRAINING — Socks (37–39)
    // ============================================
    {
      id: 'fg-037',
      name: 'Product 37',
      subtitle: 'Athletic Crew Socks — Home',
      price: '£12.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#1a3a6b',
      category: 'Socks',
      parentCategory: 'Sport & Training',
      sizes: ['S', 'M', 'L'],
      images: [],
      description: 'Cushioned crew socks in Home navy and white. Pack of 3.',
      details: ['75% Cotton, 20% Polyester, 5% Elastane', 'Cushioned sole', 'Pack of 3', 'Machine wash 40°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'S': 20, 'M': 20, 'L': 20 }
    },
    {
      id: 'fg-038',
      name: 'Product 38',
      subtitle: 'Athletic Crew Socks — Away',
      price: '£12.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Socks',
      parentCategory: 'Sport & Training',
      sizes: ['S', 'M', 'L'],
      images: [],
      description: 'Cushioned crew socks in Away red and gold. Pack of 3.',
      details: ['75% Cotton, 20% Polyester, 5% Elastane', 'Cushioned sole', 'Pack of 3', 'Machine wash 40°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'S': 20, 'M': 20, 'L': 20 }
    },
    {
      id: 'fg-039',
      name: 'Product 39',
      subtitle: 'Athletic Crew Socks — Neutral',
      price: '£12.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Socks',
      parentCategory: 'Sport & Training',
      sizes: ['S', 'M', 'L'],
      images: [],
      description: 'Cushioned crew socks in black and grey. Pack of 3. The ones you always need more of.',
      details: ['75% Cotton, 20% Polyester, 5% Elastane', 'Cushioned sole', 'Pack of 3', 'Machine wash 40°'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'S': 20, 'M': 20, 'L': 20 }
    },
  
    // ============================================
    // CASUAL & STREET — Oversized Tees (40–45)
    // ============================================
    {
      id: 'fg-040',
      name: 'Product 40',
      subtitle: 'Oversized Tee — Home',
      price: '£30.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Oversized Tees',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Heavyweight oversized tee in Home navy. Drop shoulders, boxy fit, logo chest print.',
      details: ['100% Organic Cotton', 'Oversized fit', 'Drop shoulder', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-041',
      name: 'Product 41',
      subtitle: 'Oversized Tee — Away',
      price: '£30.00',
      colors: ['#c0392b', '#e8845a'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Oversized Tees',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Heavyweight oversized tee in Away red. Makes a statement without trying.',
      details: ['100% Cotton', 'Oversized fit', 'Drop shoulder', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-042',
      name: 'Product 42',
      subtitle: 'Oversized Tee — Neutral',
      price: '£30.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#f5f0eb',
      category: 'Oversized Tees',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Cream heavyweight oversized tee. The blank canvas of your wardrobe.',
      details: ['100% Cotton', 'Oversized fit', 'Drop shoulder', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-043',
      name: 'Product 43',
      subtitle: 'Graphic Oversized Tee — Home',
      price: '£35.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1e5fbd',
      category: 'Oversized Tees',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Graphic oversized tee in royal blue. footballgirl artwork print on the back.',
      details: ['100% Organic Cotton', 'Oversized fit', 'Back graphic print', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-044',
      name: 'Product 44',
      subtitle: 'Graphic Oversized Tee — Away',
      price: '£35.00',
      colors: ['#d4a017', '#c0392b'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Oversized Tees',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Graphic oversized tee in gold. footballgirl artwork print. Bold and considered.',
      details: ['100% Cotton', 'Oversized fit', 'Back graphic print', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-045',
      name: 'Product 45',
      subtitle: 'Graphic Oversized Tee — Neutral',
      price: '£35.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Oversized Tees',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Black graphic oversized tee. footballgirl artwork. The most important tee you own.',
      details: ['100% Cotton', 'Oversized fit', 'Back graphic print', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // CASUAL & STREET — Joggers (46–51)
    // ============================================
    {
      id: 'fg-046',
      name: 'Product 46',
      subtitle: 'Jogger Pants — Home',
      price: '£52.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Joggers',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Tapered jogger pants in Home navy. Elasticated waist, cuffed hem, deep side pockets.',
      details: ['60% Recycled Cotton, 40% Recycled Polyester', 'Tapered fit', 'Deep side pockets', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-047',
      name: 'Product 47',
      subtitle: 'Jogger Pants — Away',
      price: '£52.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Joggers',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Tapered jogger pants in Away red. Wear with the Away hoodie for a full look.',
      details: ['65% Cotton, 35% Polyester', 'Tapered fit', 'Deep side pockets', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-048',
      name: 'Product 48',
      subtitle: 'Jogger Pants — Neutral',
      price: '£52.00',
      colors: ['#6b6b6b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Joggers',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Grey tapered jogger pants. The most-worn item you will ever buy.',
      details: ['65% Cotton, 35% Polyester', 'Tapered fit', 'Deep side pockets', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-049',
      name: 'Product 49',
      subtitle: 'Wide Leg Jogger — Home',
      price: '£58.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: true,
      imagePlaceholder: '#1e5fbd',
      category: 'Joggers',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Wide leg jogger in royal blue. Relaxed through the hip, wide through the leg. Fashion-forward.',
      details: ['60% Recycled Cotton, 40% Recycled Polyester', 'Wide leg', 'High waist', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-050',
      name: 'Product 50',
      subtitle: 'Wide Leg Jogger — Away',
      price: '£58.00',
      colors: ['#e8845a', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#e8845a',
      category: 'Joggers',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Wide leg jogger in coral. The warm-toned statement trouser.',
      details: ['65% Cotton, 35% Polyester', 'Wide leg', 'High waist', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
    {
      id: 'fg-051',
      name: 'Product 51',
      subtitle: 'Wide Leg Jogger — Neutral',
      price: '£58.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#f5f0eb',
      category: 'Joggers',
      parentCategory: 'Casual & Street',
      sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      images: [],
      description: 'Cream wide leg jogger. Elevated loungewear. Wears like a fashion piece.',
      details: ['65% Cotton, 35% Polyester', 'Wide leg', 'High waist', 'Machine wash 30°'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'XS': 10, 'S': 10, 'M': 10, 'L': 10, 'XL': 10, 'XXL': 10 }
    },
  
    // ============================================
    // CASUAL & STREET — Caps & Beanies (52–57)
    // ============================================
    {
      id: 'fg-052',
      name: 'Product 52',
      subtitle: 'Dad Cap — Home',
      price: '£22.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#1a3a6b',
      category: 'Caps & Beanies',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Unstructured dad cap in Home navy. Embroidered footballgirl logo. Adjustable strap.',
      details: ['100% Cotton', 'Unstructured', 'Adjustable strap', 'Spot clean only'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-053',
      name: 'Product 53',
      subtitle: 'Dad Cap — Away',
      price: '£22.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Caps & Beanies',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Unstructured dad cap in Away red. Embroidered logo. Adjustable strap.',
      details: ['100% Cotton', 'Unstructured', 'Adjustable strap', 'Spot clean only'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-054',
      name: 'Product 54',
      subtitle: 'Dad Cap — Neutral',
      price: '£22.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Caps & Beanies',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Black dad cap. Embroidered footballgirl logo. Wears with everything.',
      details: ['100% Cotton', 'Unstructured', 'Adjustable strap', 'Spot clean only'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-055',
      name: 'Product 55',
      subtitle: 'Beanie — Home',
      price: '£18.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Caps & Beanies',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Ribbed knit beanie in Home navy. Embroidered logo. Warm, simple, essential.',
      details: ['100% Recycled Acrylic', 'Ribbed knit', 'One size fits most', 'Hand wash cold'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-056',
      name: 'Product 56',
      subtitle: 'Beanie — Away',
      price: '£18.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Caps & Beanies',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Ribbed knit beanie in Away gold. Embroidered logo. Stands out on a cold touchline.',
      details: ['100% Acrylic', 'Ribbed knit', 'One size fits most', 'Hand wash cold'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-057',
      name: 'Product 57',
      subtitle: 'Beanie — Neutral',
      price: '£18.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Caps & Beanies',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Black ribbed beanie. Embroidered logo. The most-needed item in your winter kit bag.',
      details: ['100% Acrylic', 'Ribbed knit', 'One size fits most', 'Hand wash cold'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
  
    // ============================================
    // CASUAL & STREET — Tote Bags (58–63)
    // ============================================
    {
      id: 'fg-058',
      name: 'Product 58',
      subtitle: 'Canvas Tote Bag — Home',
      price: '£20.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#f0f4ff',
      category: 'Tote Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Heavy canvas tote in natural with Home navy footballgirl print. Carries everything. Says everything.',
      details: ['100% Heavy Canvas', '38L capacity', 'Reinforced handles', 'Spot clean only'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-059',
      name: 'Product 59',
      subtitle: 'Canvas Tote Bag — Away',
      price: '£20.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Tote Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Heavy canvas tote in red with Away gold footballgirl print.',
      details: ['100% Heavy Canvas', '38L capacity', 'Reinforced handles', 'Spot clean only'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-060',
      name: 'Product 60',
      subtitle: 'Canvas Tote Bag — Neutral',
      price: '£20.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Tote Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Black canvas tote with cream footballgirl print. Simple, strong, always right.',
      details: ['100% Heavy Canvas', '38L capacity', 'Reinforced handles', 'Spot clean only'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 30 }
    },
    {
      id: 'fg-061',
      name: 'Product 61',
      subtitle: 'Zip Tote — Home',
      price: '£28.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Tote Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Zipped tote in navy. Secure closure, inner pocket, water-resistant lining.',
      details: ['100% Recycled Polyester', 'Zip closure', 'Inner pocket', 'Water-resistant lining'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'One Size': 20 }
    },
    {
      id: 'fg-062',
      name: 'Product 62',
      subtitle: 'Zip Tote — Away',
      price: '£28.00',
      colors: ['#c0392b', '#e8845a'],
      isRecycled: false,
      imagePlaceholder: '#e8845a',
      category: 'Tote Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Zipped tote in coral. Your kit bag upgrade.',
      details: ['100% Polyester', 'Zip closure', 'Inner pocket', 'Water-resistant lining'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'One Size': 20 }
    },
    {
      id: 'fg-063',
      name: 'Product 63',
      subtitle: 'Zip Tote — Neutral',
      price: '£28.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Tote Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Black zipped tote. Goes to training, goes to the office, goes everywhere.',
      details: ['100% Polyester', 'Zip closure', 'Inner pocket', 'Water-resistant lining'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'One Size': 20 }
    },
  
    // ============================================
    // CASUAL & STREET — Backpacks (64–66)
    // ============================================
    {
      id: 'fg-064',
      name: 'Product 64',
      subtitle: 'Backpack — Home',
      price: '£45.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: true,
      imagePlaceholder: '#1a3a6b',
      category: 'Backpacks',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Everyday backpack in Home navy. Laptop sleeve, water bottle pocket, padded straps.',
      details: ['100% Recycled Polyester', 'Laptop sleeve fits 15"', 'Water bottle pocket', 'Padded straps'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'One Size': 15 }
    },
    {
      id: 'fg-065',
      name: 'Product 65',
      subtitle: 'Backpack — Away',
      price: '£45.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Backpacks',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Everyday backpack in Away red. Makes you visible. Makes a statement.',
      details: ['100% Polyester', 'Laptop sleeve fits 15"', 'Water bottle pocket', 'Padded straps'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'One Size': 15 }
    },
    {
      id: 'fg-066',
      name: 'Product 66',
      subtitle: 'Backpack — Neutral',
      price: '£45.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Backpacks',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Black everyday backpack. The most useful thing in your collection.',
      details: ['100% Polyester', 'Laptop sleeve fits 15"', 'Water bottle pocket', 'Padded straps'],
      collection: 'The Training Edit',
      motion: 'standard',
      stock: { 'One Size': 15 }
    },
  
    // ============================================
    // CASUAL & STREET — Crossbody Bags (67–69)
    // ============================================
    {
      id: 'fg-067',
      name: 'Product 67',
      subtitle: 'Crossbody Bag — Home',
      price: '£32.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#1a3a6b',
      category: 'Crossbody Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Mini crossbody in navy. Adjustable strap, zip closure, card slot interior.',
      details: ['100% Vegan Leather', 'Adjustable strap', 'Zip closure', 'Card slot interior'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 15 }
    },
    {
      id: 'fg-068',
      name: 'Product 68',
      subtitle: 'Crossbody Bag — Away',
      price: '£32.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Crossbody Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Mini crossbody in gold. The finishing touch on every Away colourway outfit.',
      details: ['100% Vegan Leather', 'Adjustable strap', 'Zip closure', 'Card slot interior'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 15 }
    },
    {
      id: 'fg-069',
      name: 'Product 69',
      subtitle: 'Crossbody Bag — Neutral',
      price: '£32.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Crossbody Bags',
      parentCategory: 'Casual & Street',
      sizes: ['One Size'],
      images: [],
      description: 'Black mini crossbody. Goes with every outfit in this store.',
      details: ['100% Vegan Leather', 'Adjustable strap', 'Zip closure', 'Card slot interior'],
      collection: 'The Weekend Edit',
      motion: 'standard',
      stock: { 'One Size': 15 }
    },
  
    // ============================================
    // KIDS & BABY — Baby Bodysuits (70–72)
    // ============================================
    {
      id: 'fg-070',
      name: 'Product 70',
      subtitle: 'Baby Bodysuit — Home',
      price: '£16.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#f0f4ff',
      category: 'Baby Bodysuits',
      parentCategory: 'Kids & Baby',
      sizes: ['0-3M', '3-6M', '6-12M', '12-18M'],
      images: [],
      description: 'Soft cotton baby bodysuit in Home white with navy footballgirl logo. Snap closure.',
      details: ['100% Organic Cotton', 'Snap closure', 'Pre-shrunk', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '0-3M': 20, '3-6M': 20, '6-12M': 20, '12-18M': 20 }
    },
    {
      id: 'fg-071',
      name: 'Product 71',
      subtitle: 'Baby Bodysuit — Away',
      price: '£16.00',
      colors: ['#c0392b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Baby Bodysuits',
      parentCategory: 'Kids & Baby',
      sizes: ['0-3M', '3-6M', '6-12M', '12-18M'],
      images: [],
      description: 'Soft cotton baby bodysuit in Away red. Future footballgirl. Snap closure.',
      details: ['100% Organic Cotton', 'Snap closure', 'Pre-shrunk', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '0-3M': 20, '3-6M': 20, '6-12M': 20, '12-18M': 20 }
    },
    {
      id: 'fg-072',
      name: 'Product 72',
      subtitle: 'Baby Bodysuit — Neutral',
      price: '£16.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#f5f0eb',
      category: 'Baby Bodysuits',
      parentCategory: 'Kids & Baby',
      sizes: ['0-3M', '3-6M', '6-12M', '12-18M'],
      images: [],
      description: 'Cream cotton baby bodysuit with black footballgirl logo. Classic and clean.',
      details: ['100% Organic Cotton', 'Snap closure', 'Pre-shrunk', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '0-3M': 20, '3-6M': 20, '6-12M': 20, '12-18M': 20 }
    },
  
    // ============================================
    // KIDS & BABY — Kids T-Shirts (73–78)
    // ============================================
    {
      id: 'fg-073',
      name: 'Product 73',
      subtitle: 'Kids T-Shirt — Home',
      price: '£18.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: false,
      imagePlaceholder: '#1e5fbd',
      category: 'Kids T-Shirts',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids t-shirt in Home royal blue. Soft jersey, footballgirl chest logo. For the next generation.',
      details: ['100% Cotton', 'Regular fit', 'Pre-shrunk', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-074',
      name: 'Product 74',
      subtitle: 'Kids T-Shirt — Away',
      price: '£18.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Kids T-Shirts',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids t-shirt in Away red. Bold colourway for bold little players.',
      details: ['100% Cotton', 'Regular fit', 'Pre-shrunk', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-075',
      name: 'Product 75',
      subtitle: 'Kids T-Shirt — Neutral',
      price: '£18.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Kids T-Shirts',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids t-shirt in black. Simple, cool, footballgirl.',
      details: ['100% Cotton', 'Regular fit', 'Pre-shrunk', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-076',
      name: 'Product 76',
      subtitle: 'Kids Graphic Tee — Home',
      price: '£22.00',
      colors: ['#1e5fbd', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#f0f4ff',
      category: 'Kids T-Shirts',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids graphic tee in white with Home navy football artwork. For the ones who love the game.',
      details: ['100% Cotton', 'Regular fit', 'Graphic back print', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-077',
      name: 'Product 77',
      subtitle: 'Kids Graphic Tee — Away',
      price: '£22.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#d4a017',
      category: 'Kids T-Shirts',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids graphic tee in gold with Away red football artwork.',
      details: ['100% Cotton', 'Regular fit', 'Graphic back print', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-078',
      name: 'Product 78',
      subtitle: 'Kids Graphic Tee — Neutral',
      price: '£22.00',
      colors: ['#6b6b6b', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Kids T-Shirts',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids graphic tee in grey. Laid-back and cool, just like them.',
      details: ['100% Cotton', 'Regular fit', 'Graphic back print', 'Machine wash 40°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
  
    // ============================================
    // KIDS & BABY — Kids Hoodies (79–81)
    // ============================================
    {
      id: 'fg-079',
      name: 'Product 79',
      subtitle: 'Kids Hoodie — Home',
      price: '£35.00',
      colors: ['#1a3a6b', '#1e5fbd'],
      isRecycled: false,
      imagePlaceholder: '#1a3a6b',
      category: 'Kids Hoodies',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids pullover hoodie in Home navy. Soft brushed interior, kangaroo pocket.',
      details: ['65% Cotton, 35% Polyester', 'Brushed interior', 'Kangaroo pocket', 'Machine wash 30°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-080',
      name: 'Product 80',
      subtitle: 'Kids Hoodie — Away',
      price: '£35.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Kids Hoodies',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids pullover hoodie in Away red. Bold colour for bold kids.',
      details: ['65% Cotton, 35% Polyester', 'Brushed interior', 'Kangaroo pocket', 'Machine wash 30°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
    {
      id: 'fg-081',
      name: 'Product 81',
      subtitle: 'Kids Hoodie — Neutral',
      price: '£35.00',
      colors: ['#1a1a1a', '#6b6b6b'],
      isRecycled: false,
      imagePlaceholder: '#6b6b6b',
      category: 'Kids Hoodies',
      parentCategory: 'Kids & Baby',
      sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y', '11-12Y'],
      images: [],
      description: 'Kids pullover hoodie in grey. The one they will wear every single day.',
      details: ['65% Cotton, 35% Polyester', 'Brushed interior', 'Kangaroo pocket', 'Machine wash 30°'],
      collection: 'The Next Generation Edit',
      motion: 'standard',
      stock: { '3-4Y': 15, '5-6Y': 15, '7-8Y': 15, '9-10Y': 15, '11-12Y': 15 }
    },
  
    // ============================================
    // BONUS — Home & Living tasters (82–84)
    // So Home & Living category is never empty
    // ============================================
    {
      id: 'fg-082',
      name: 'Product 82',
      subtitle: 'footballgirl Mug — Home',
      price: '£14.00',
      colors: ['#1a3a6b', '#f0f4ff'],
      isRecycled: false,
      imagePlaceholder: '#1a3a6b',
      category: 'Mugs',
      parentCategory: 'Home & Living',
      sizes: ['One Size'],
      images: [],
      description: '350ml ceramic mug in Home navy. footballgirl logo print. Dishwasher safe.',
      details: ['Ceramic', '350ml', 'Dishwasher safe', 'Microwave safe'],
      collection: 'The Home Edit',
      motion: 'standard',
      stock: { 'One Size': 50 }
    },
    {
      id: 'fg-083',
      name: 'Product 83',
      subtitle: 'footballgirl Mug — Away',
      price: '£14.00',
      colors: ['#c0392b', '#d4a017'],
      isRecycled: false,
      imagePlaceholder: '#c0392b',
      category: 'Mugs',
      parentCategory: 'Home & Living',
      sizes: ['One Size'],
      images: [],
      description: '350ml ceramic mug in Away red. footballgirl logo. Start the day in your colours.',
      details: ['Ceramic', '350ml', 'Dishwasher safe', 'Microwave safe'],
      collection: 'The Home Edit',
      motion: 'standard',
      stock: { 'One Size': 50 }
    },
    {
      id: 'fg-084',
      name: 'Product 84',
      subtitle: 'footballgirl Mug — Neutral',
      price: '£14.00',
      colors: ['#1a1a1a', '#f5f0eb'],
      isRecycled: false,
      imagePlaceholder: '#1a1a1a',
      category: 'Mugs',
      parentCategory: 'Home & Living',
      sizes: ['One Size'],
      images: [],
      description: '350ml ceramic mug in black. Clean, minimal, footballgirl.',
      details: ['Ceramic', '350ml', 'Dishwasher safe', 'Microwave safe'],
      collection: 'The Home Edit',
      motion: 'standard',
      stock: { 'One Size': 50 }
    }
  
  ];
  
  // ============================================
  // CURRENCIES
  // ============================================
  export const CURRENCIES = [
    { code: 'GBP', symbol: '£', label: 'GBP £' },
    { code: 'EUR', symbol: '€', label: 'EUR €' },
    { code: 'USD', symbol: '$', label: 'USD $' }
  ];